import Skeleton from 'react-loading-skeleton';

export const SkeletonCellRenderer = (params) => {
  return <Skeleton width={params.column.actualWidth ? params.column.actualWidth - 20 : 100} />;
};
